module.exports = __webpack_public_path__ + "img/10.5768ce0e.png";